import React from 'react';

import { AppStateContext } from 'contexts/appStateContext';

export const useAppState = () => {
  return React.useContext(AppStateContext);
};
